import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

// Mixin providing authorization methods
export default {
  name: 'DataTableAuthorizationMixin',

  computed: {
    ...mapGetters({
      'selectedContext': 'contextStore/selectedContext',
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId',
      'trackerTypeId': 'contextStore/trackerTypeId',
      userId: 'userDataStore/userId'
    })
  },

  methods: {
    userCanAccessFeatureDataTable (featureId, accessType) {
      return Configuration.auth.userCanAccessFeatureDataTable(this.selectedContext, featureId, accessType)
    },

    userCanDo (operation, item) {
      if (item) {
        return Configuration.auth.userCanDo(this.selectedContext, operation, item, this.userId)
      }
      return Configuration.auth.userCanDo(this.selectedContext, operation)
    },

    userCanAccessField (colId) {
      return Configuration.auth.userCanAccessField(this.selectedContext, colId)
    },

    userCanAccessFeature (featureId, operation) {
      if (operation) {
        return Configuration.auth.userCanAccessFeature(
          this.selectedContext, featureId, operation)
      } else {
        return Configuration.auth.userCanAccessFeature(
          this.selectedContext, featureId)
      }
    },

    userCanDoAndAccessFeature (feature, operation) {
      return Configuration.auth.userCanDoAndAccessFeature(this.selectedContext, feature, operation, this.trackerDTO, this.userId)
    },

    userCanViewOwned () {
      const viewOwned = `/${this.applicationId}`
        .concat(`/workspace/${this.workspaceId}`)
        .concat(`/tracker/${this.trackerTypeId}`)
        .concat(`?op=get&on=owned`)
      return Configuration.auth.userHasPrivilege(viewOwned)
    }
  }
}
